<template>
     <div class="d-flex justify-space-between py-4">
              <h4 class="font-weight-bold accent--text">{{ $t(getSuggestionText) }}</h4>
              <v-btn
                text
                color="accent"
                class="text-none"
                @click="goViewAllRecipw()"
                >{{ $t('view_all') }}</v-btn
              >
            </div>
</template>
 
<script>

export default {
  title: "Header By Time",
  name: "HeaderByTime",
  components: {
    // Card3,
  },

  props: {
    recipes: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({}),

  methods: {

goViewAllRecipw() {
      this.$router.push(
        { name: "viewAll", params: { recipes: this.recipes } },
        () => {}
      );
    },
  },

  computed:{
    getSuggestionText() {
    const hour = (new Date()).getHours();
        
    if (hour >= 3 && hour < 10)
      return "meal_suggestion_by_time.1";
    else if (hour >= 10 && hour < 11)
      return "meal_suggestion_by_time.2";
    else if (hour >= 11 && hour < 15)
      return "meal_suggestion_by_time.3";
    else if (hour >= 15 && hour < 18)
      return "meal_suggestion_by_time.4";
    else if (hour >= 18 && hour < 22)
      return "meal_suggestion_by_time.4";
    return "meal_suggestion_by_time.6";

  }
  }


};
</script>

<style scoped lang="scss">
.card-category {
  width: 20%;
  /* width: 33.33%; */
  position: relative;
  .v-image {
    border-radius: 8px;
  }
}

@media (max-width: 900px) {
  .card-category {
   width: 25%;
  }
}
@media (max-width: 600px) {
  .card-category {
    width: 50%;
  }
}

.title {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  color: white;
}
</style>